import React, {ReactElement} from 'react';

import * as S from './ReportPageHeader.styles';

type ReportPageMenuItemProps = {
  applyMarginTop: boolean;
  applyMarginBottom: boolean;
  destructive?: boolean;
  text: string;
  icon: ReactElement;
  onClick: (e: React.MouseEvent) => void;
  toggle?: ReactElement;
};

export const ReportPageMenuItem = ({
  applyMarginTop,
  applyMarginBottom,
  destructive,
  text,
  icon,
  onClick,
  toggle,
}: ReportPageMenuItemProps) => {
  return (
    <S.ReportActionsMenuItem
      data-test="report-menu-item"
      $applyMarginTop={applyMarginTop}
      $applyMarginBottom={applyMarginBottom}
      $destructive={destructive}
      key={text}
      onClick={onClick}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          {icon}
          <p>{text}</p>
        </div>
        {toggle}
      </div>
    </S.ReportActionsMenuItem>
  );
};
